import { Link } from "react-router-dom";
import { documents, type Language, type Slug } from "./documents";

/** The other language's address for the same document. */
const other: Record<Language, Language> = { en: "it", it: "en" };

function path(slug: Slug, language: Language): string {
  return language === "en" ? `/app/${slug}` : `/app/${slug}/it`;
}

const switchLabel: Record<Language, string> = { en: "English", it: "Italiano" };

const backLabel: Record<Language, string> = { en: "← Back", it: "← Indietro" };

/** The other three documents, so a reader who landed on one can find the rest. */
const alsoLabel: Record<Language, string> = { en: "See also", it: "Vedi anche" };

/**
 * One layout for every legal page.
 *
 * These are the pages an app store checks before it will publish, and the ones a reader reaches
 * when something has gone wrong — so they are plain text on a plain ground, with the language
 * switch and the way back always in the same place.
 */
export function LegalPage({ slug, language }: { slug: Slug; language: Language }) {
  const document = documents[slug][language];
  const siblings = (Object.keys(documents) as Slug[]).filter((each) => each !== slug);

  return (
    <div className="shell">
      <div className="header">
        <h1 className="wordmark">Gymquisition</h1>
        <Link className="tag" to={path(slug, other[language])}>
          {switchLabel[other[language]]}
        </Link>
      </div>

      <article className="prose">
        <h1>{document.title}</h1>
        <p className="updated">{document.updated}</p>
        {document.body}

        <hr />
        <p className="also">
          {alsoLabel[language]}:{" "}
          {siblings.map((each, index) => (
            <span key={each}>
              {index > 0 ? " · " : ""}
              <Link to={path(each, language)}>{documents[each][language].title}</Link>
            </span>
          ))}
        </p>
      </article>

      <Link className="back" to="/app">
        {backLabel[language]}
      </Link>
    </div>
  );
}
